var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMosaicExitFullscreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.77,
    height: 39.377,
    viewBox: "0 0 39.77 39.377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3332",
    "data-name": "Group 3332",
    transform: "translate(-319.098 -18.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M333.4,33.483a1,1,0,0,1-.71-.3l-13.3-13.427a1,1,0,0,1,1.421-1.407l13.3,13.426a1,1,0,0,1-.71,1.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M334.4,33.841H323.375a1,1,0,0,1,0-2H332.4V23.017a1,1,0,1,1,2,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M320.1,57.431a1,1,0,0,1-.7-1.71l13.429-13.3a1,1,0,0,1,1.407,1.421L320.8,57.141a1,1,0,0,1-.7.29",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M333.884,54.16a1,1,0,0,1-1-1V44.134h-8.822a1,1,0,0,1,0-2h10.822V53.16a1,1,0,0,1-1,1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M357.868,57.429a1,1,0,0,1-.71-.3l-13.3-13.426a1,1,0,0,1,1.421-1.407l13.3,13.425a1,1,0,0,1-.71,1.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M344.57,53.468a1,1,0,0,1-1-1V41.644H354.6a1,1,0,0,1,0,2H345.57v8.824a1,1,0,0,1-1,1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M344.439,33.353a1,1,0,0,1-.7-1.71l13.429-13.3a1,1,0,0,1,1.407,1.421l-13.428,13.3a1,1,0,0,1-.7.29",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M353.9,33.353H343.082V22.326a1,1,0,1,1,2,0v9.027H353.9a1,1,0,0,1,0,2",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosaicExitFullscreen);
export default __webpack_public_path__ + "static/media/MosaicExitFullscreen.ea906f71a9fdfe0c3823abe5ce590e96.svg";
export { ForwardRef as ReactComponent };